'use client';

import { useEffect, useState } from 'react';

import { MDXRemote } from 'next-mdx-remote';
import { serialize } from 'next-mdx-remote/serialize';
import rehypePrettyCode from 'rehype-pretty-code';

import RehypePrettyCodeCopy from './rehype-pretty-code/rehypePrettyCodeCopy';
import { rehypePrettyCodeOptions } from './rehype-pretty-code/rehypePrettyCodeOptions';

const CodeBlock = (props: any) => {
  const { fields } = props.node;

  const [compiledMDX, setCompiledMDX] = useState<any>(null);

  const convertToMDX = async () => {
    try {
      const mdxSource = await serialize(
        `\`\`\`${fields.language} ${fields.title ? 'title="' + fields.title + '"' : ''} ${fields.showLineNumbers ? 'showLineNumbers' : ''}\n${fields.code}\n\`\`\``,
        {
          mdxOptions: {
            remarkPlugins: [],
            rehypePlugins: [[rehypePrettyCode, rehypePrettyCodeOptions]],
          },
        },
      );
      setCompiledMDX(mdxSource);
    } catch (error) {
      console.error('Error converting markdown:', error);
    }
  };
  useEffect(() => {
    convertToMDX();
  }, []);

  if (!compiledMDX) {
    return null;
  }

  return (
    <>
      <RehypePrettyCodeCopy />
      <MDXRemote {...compiledMDX} />
    </>
  );
};

export default CodeBlock;
